import React from "react";
import { Field } from "formik";
import { Flex } from "../../../Flex";
import { FormikCheckbox } from "../../../FormikCheckbox";
import { Span } from "../../../Span";
import { layout, LayoutProps, space, SpaceProps } from "styled-system";
import styled from "styled-components";

interface Props {
  id: string;
}

interface CheckboxWrapperProps extends LayoutProps, SpaceProps {}

const CheckboxWrapper = styled.div<CheckboxWrapperProps>`
  ${layout}
  ${space}
  max-width: ${({ theme }) => theme.breakpoints[0] && "300px"};
`;

export const DisconnectionPropertyDetailsIssues: React.FC<Props> = ({ id }) => {
  return (
    <Flex
      id={id}
      flexDirection="column"
      flexGrow={0.3}
      flexBasis={0}
      minWidth={["100%", "100%", "100%", 0]}
      mb={[3, 3, 3, 0]}
      mt={4}
    >
      <Flex pl={2} pr={2}>
        <Span
          display="inline-block"
          fontSize={2}
          lineHeight={2}
          fontWeight="medium"
        >
          Do any of the below access issues apply to the property?
        </Span>
      </Flex>
      <Flex
        mt={3}
        flexDirection={["column", "column", "column", "row", "row"]}
        flexWrap={["wrap", "wrap", "wrap", "nowrap", "nowrap"]}
      >
        <CheckboxWrapper mr={2} mb={[4, 4, 4, 0, 0]}>
          <Field
            id={"propertyDetails.guardDogs"}
            name={"propertyDetails.guardDogs"}
            label={"Guard Dog(s)"}
            focusable={true}
            component={FormikCheckbox}
            mr={2}
            optional
          />
        </CheckboxWrapper>
        <CheckboxWrapper mb={[4, 4, 4, 0, 0]}>
          <Field
            id={"propertyDetails.lockedGate"}
            name={"propertyDetails.lockedGate"}
            label={"Locked Gate"}
            focusable={true}
            component={FormikCheckbox}
            optional
          />
        </CheckboxWrapper>
      </Flex>
    </Flex>
  );
};
